import { render, staticRenderFns } from "./PlayerRestorations.vue?vue&type=template&id=2f35f837&"
import script from "./PlayerRestorations.vue?vue&type=script&lang=js&"
export * from "./PlayerRestorations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports